import React from "react";

const TrashIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.62793 5.52539L2.60656 17.3392C2.6767 18.1912 3.40239 18.8592 4.2576 18.8592H13.2747C14.1299 18.8592 14.8556 18.1912 14.9257 17.3392L15.9043 5.52539H1.62793ZM6.00307 16.6492C5.71385 16.6492 5.47053 16.4242 5.45219 16.1312L4.89968 7.21742C4.88079 6.91258 5.11225 6.65037 5.41657 6.63147C5.7322 6.60933 5.98311 6.84352 6.00252 7.14836L6.55502 16.0621C6.57458 16.3778 6.32481 16.6492 6.00307 16.6492ZM9.31862 16.0967C9.31862 16.402 9.0715 16.6492 8.76611 16.6492C8.46072 16.6492 8.21361 16.402 8.21361 16.0967V7.18291C8.21361 6.87752 8.46072 6.6304 8.76611 6.6304C9.0715 6.6304 9.31862 6.87752 9.31862 7.18291V16.0967ZM12.6325 7.21746L12.08 16.1312C12.0619 16.4212 11.8201 16.6629 11.4941 16.6481C11.1898 16.6292 10.9583 16.367 10.9772 16.0621L11.5297 7.14839C11.5486 6.84356 11.8157 6.62178 12.1157 6.63151C12.42 6.6504 12.6514 6.91262 12.6325 7.21746Z"
        fill="currentColor"
      />
      <path
        d="M15.9487 2.21002H12.6336V1.65752C12.6336 0.743525 11.8901 0 10.9761 0H6.55607C5.64208 0 4.89856 0.743525 4.89856 1.65752V2.21002H1.58353C0.973229 2.21002 0.478516 2.70473 0.478516 3.31503C0.478516 3.92525 0.973229 4.42004 1.58353 4.42004C6.66532 4.42004 10.8671 4.42004 15.9487 4.42004C16.559 4.42004 17.0537 3.92525 17.0537 3.31503C17.0537 2.70473 16.559 2.21002 15.9487 2.21002ZM11.5286 2.21002H6.00357V1.65752C6.00357 1.35268 6.25124 1.10501 6.55607 1.10501H10.9761C11.281 1.10501 11.5286 1.35268 11.5286 1.65752V2.21002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TrashIcon;
